import { HeaderPortal } from '@/templates/app-shell/components/header/components/header-portal';
import {
	Box,
	ButtonGroup,
	Grid,
	IconButton,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { FiCalendar, FiEdit, FiEye, FiSettings, FiTrash } from 'react-icons/fi';
import { TbCalendarPlus } from 'react-icons/tb';
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc';
import { VISIBLE_DAYS, useBookingPlannerController } from './booking-planner.controller';
import { EditCalendarModal } from './components/edit-calendar-modal/edit-calendar-modal.view';
import EventDetailsModal from './components/event-details-modal/event-details.view';
import EventList from './components/event-list/event-list.view';
import PendingEvents from './components/pending-events/pending-events.view';

export function BookingPlannerView() {
	const {
		calendarQuery,
		events,
		fromInstant,
		hidePending,
		isModalOpen,
		pendingEvents,
		isEditCalendarModalOpen,
		handleCloseClick,
		handleCreateEventClick,
		handleEditCalendarClick,
		handleEditCalendarCloseClick,
		handleEventClick,
		handleMonthClick,
		handleNextClick,
		handlePrevClick,
		handleRemoveCalendarClick,
		handleShowPendingClick,
	} = useBookingPlannerController();

	return (
		<Box w="full" h="full" overflow="auto">
			<EventDetailsModal isOpen={isModalOpen} onClose={handleCloseClick} />
			{calendarQuery.data ? (
				<EditCalendarModal
					calendar={calendarQuery.data}
					isOpen={isEditCalendarModalOpen}
					onClose={handleEditCalendarCloseClick}
				/>
			) : null}

			<HeaderPortal>
				<Grid alignContent="center" justifyContent="center" gridTemplateColumns="1fr auto" w="full" h="full" px={4}>
					<ButtonGroup isAttached variant="outline">
						<IconButton onClick={handlePrevClick} aria-label={t('Back')} icon={<VscChevronLeft />}></IconButton>
						<IconButton onClick={handleNextClick} aria-label={t('Next')} icon={<VscChevronRight />}></IconButton>
					</ButtonGroup>

					<ButtonGroup isAttached variant="ghost" size="lg">
						<IconButton
							onClick={handleCreateEventClick}
							icon={<TbCalendarPlus />}
							aria-label={t('Create event')}
						></IconButton>

						<Menu>
							<MenuButton size="lg" as={IconButton} icon={<FiSettings />} />
							<MenuList>
								<MenuItem icon={<FiEdit />} onClick={handleEditCalendarClick}>
									{t('Edit')}
								</MenuItem>

								<MenuDivider />

								<MenuItem icon={<FiCalendar />} onClick={handleMonthClick}>
									{t('Month')}
								</MenuItem>

								<MenuItem icon={<FiEye />} onClick={handleShowPendingClick}>
									{t('Toggle pending')}
								</MenuItem>

								<MenuDivider />

								<MenuItem icon={<FiTrash />} onClick={handleRemoveCalendarClick}>
									{t('Delete calendar')}
								</MenuItem>
							</MenuList>
						</Menu>
					</ButtonGroup>
				</Grid>
			</HeaderPortal>

			<Box display="grid" gridTemplateColumns={hidePending ? '1fr' : 'auto 1fr'} h="full" overflow="auto">
				{hidePending ? null : <PendingEvents events={pendingEvents} onEventClick={handleEventClick} />}
				<EventList
					visibleDays={VISIBLE_DAYS}
					events={events}
					onEventClick={handleEventClick}
					fromInstant={fromInstant}
				/>
			</Box>
		</Box>
	);
}
